import { FC } from 'react';
import { Divider, Form, Table } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationUnit } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportUnitForm = {
	lists: OfficeObservationUnit<'payload'>[];
};

const FBDHVisitReportUnits: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { technicalAspect } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportUnitForm>();

	return (
		<Form.Provider>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: technicalAspect?.units ?? [],
					} as VisitReportUnitForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportUnitForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										width: 1,
										align: 'center',
										render: (_, __, index) => index + 1,
									},
									{
										title: 'Jumlah Unit',
										render: (_, record) => record.unitAmount ?? '-',
									},
									{
										title: 'Detail Merk Unit',
										render: (_, record) => record.unitBrandDetail ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
				<Divider />
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportUnits;
